import { fetchTemplateSettings } from '@eliadmin/core/src/api/general/general-api';
import Link from '@eliadmin/core/src/components/link';
import { getServerState } from '@eliadmin/core/src/utils/server-state';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { getSafeHref, isRelativeHref } from '@eliadmin/core/src/utils/url-utils';
import type { PropsWithChildren } from 'react';

export type CategoryMenuProps = {
  className?: string;
};

export function CategoryMenu(props: PropsWithChildren<CategoryMenuProps>) {
  return (
    <ul className={cn('flex flex-row items-center gap-2', 'ea-category-menu', props.className)}>
      {props.children}
    </ul>
  );
}

export type CategoryMenuItemProps = {
  title: string;
  href?: string;
  onClick?: () => void;
  order?: number;
  className?: {
    root?: string;
    link?: string;
  };
};

export async function CategoryMenuItem(props: CategoryMenuItemProps) {
  const locale = getServerState().getCurrentLocale();
  const safeHref = props.href ? getSafeHref(props.href) : '#';
  const isInternalHref = props.href ? isRelativeHref(safeHref) : false;
  const LinkComp = props.href ? (isInternalHref ? Link : 'a') : 'span';
  const templateSettings = await fetchTemplateSettings({ locale });

  const title = templateSettings?.data?.realty_header ? props.title.toUpperCase() : props.title;

  return (
    <li
      style={{ order: props.order }}
      className={cn(
        'flex flex-row',
        {
          'cursor-pointer hover:underline': !!props.href,
          'cursor-default': !props.href,
        },
        'ea-category-menu-item',
        props.className?.root,
      )}
    >
      <LinkComp
        href={safeHref}
        className={cn('text-sm font-medium', 'ea-category-menu-item__link', props.className?.link)}
        onClick={props.onClick}
        {...(isInternalHref ? { prefetchOnHover: true } : {})}
      >
        {title}
      </LinkComp>
    </li>
  );
}
